import { render, staticRenderFns } from "./AbUiCard.vue?vue&type=template&id=4c522bab&scoped=true&"
import script from "./AbUiCard.vue?vue&type=script&lang=js&"
export * from "./AbUiCard.vue?vue&type=script&lang=js&"
import style0 from "./AbUiCard.vue?vue&type=style&index=0&id=4c522bab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c522bab",
  null
  
)

export default component.exports